import React, { Component, Fragment } from 'react';
import { ReactComponent as StopIcon } from 'Icons/stop.svg';
import { ReactComponent as AddStopsIcon } from 'Icons/addstops.svg';
import { ReactComponent as CloseIcon } from 'Icons/close-circle.svg';
import Select from 'react-select';
import Input from 'Components/Input/index';
import Checkbox from 'Components/Checkbox/index';
import { getUser } from 'Utils/storage';
import ClickOutside from 'Components/ClickOutside';
import { AVG_DISTANCE } from 'Constants/commonConstants';

class StopDetails extends Component {
    constructor(props) {
        super(props);
		this.trip = props.trip;
		this.viewMode = props.viewMode;
		this.stops = this.trip.stops;
		this.state = {
			stops: this.trip.stops,
			fromLoc: null,
			toLoc: null,
			searchFromText: '',
			searchToText: '',
			consignees: this.trip.consignees,
			consigners: this.trip.consigners,
			routeCode: '',
			fromRange: this.trip.fromRange || '',
			toRange: this.trip.toRange || ''
		}
    }

    addStop = () => {
		if (this.viewMode) {
			return;
		}
		this.props.trip.addStop();
		this.setState({
			stops: this.trip.stops
		});
	}

    removeStop = (index) => {
		if (this.viewMode) {
			return;
		}
		this.trip.removeStop(index);
		this.setState({
			stops: this.trip.stops
		});
		this.props.onChange();
	}

    onhideAutosuggest = (type) => {
		this.setState({ [type]: false });
	}

    onChange = (e, index) => {
		const dropdownType = `show${e.target.name}Autosuggest`;
        const { value } = e.target;
		this.setState({
			[e.target.name]: e.target.value,
			[dropdownType]: true,
		});
        let from = '';
        let to = '';
        from = (index === 0 ? value : ((this.stops[0] || {}).location || '').split(',')[0]);
        to = index === 1 ? value : undefined;
        this.props.getMasterRouteCodeDetails( from, to );
		this.setLocation(index, value);
	}

    onSelect = (type, item, index) => {
		const name = `${item[index === 0 ?  'source' : 'destination']}, ${item[index === 0 ? 'source_district' : 'destination_district']} ,${item[`${index === 0 ? 'source_state' : 'destination_state'}`]}`
		const dropdownType = `show${type}Autosuggest`;
		this.setState({
			[type]: name ? name : this.state[type],
			[dropdownType]: false
		})
        item.city = item[index === 0 ? 'source' : 'destination'];
        item.location = index === 0 ? `${item.source},${item.source_district}, ${item.source_state}` : `${item.destination}, ${item.destination_district}, ${item.destination_state}`
        item.state = item[index === 0 ? 'source_state' : 'destination_state'];
        if(index === 1 ? (this.stops[0] || {}).location : (this.stops[1] || {}).location) {
            this.trip.routeCode = item.sap_code;
            this.trip.distance = item.distance;
            this.trip.distance_uom = item.distance_uom;
            this.trip.addRouteCode(item.sap_code);
            if(item.distance) {
                let tat = (parseFloat(item.distance.replace(/[\s,]+/g, '')) / AVG_DISTANCE)
                if (item.distance < 250) {
                    tat = 1
                }
                this.trip.biddingDetails.setTatValue(Math.round(tat));
                this.trip.biddingDetails.setTatUnit({ name:"Days", value:1 });
            }
        }
		this.setLocation(index, item);
	}

    setLocation = (index, location) => {
		if (this.viewMode) {
			return;
		}
		this.state.stops[index].setLocation(location);
		this.props.onChange('stop');
	}

    changeRemarks = (index, e) => {
		if (this.viewMode) {
			return;
		}
		const stops = [...this.state.stops];
		stops[index].remarks = e.target.value;
		this.setState({
			stops
		});
		this.stops[index].setRemarks(e.target.value);
	}

    changeLandmark = (index, e) => {
		if (this.viewMode) {
			return;
		}
		const stops = [...this.state.stops];
		stops[index].landmark = e.target.value;
		this.setState({
			stops
		})
		this.stops[index].setLandmark(e.target.value);
	}

    changeStopType = (index, type) => {
		if (this.viewMode) {
			return;
		}
		const stops = [...this.state.stops];
		stops[index].type = type;
		this.setState({
			stops
		})
		this.stops[index].setType(type);
	}
	changeAdditionalPrice = (index, e) => {
		if (this.viewMode) {
			return;
		}
		const stops = [...this.state.stops];
		stops[index].additionalPrice = e.target.value;
		this.setState({
			stops
		});
		this.stops[index].setAdditionalPrice(e.target.value);
	}

    render() {
        const { stops, searchFromText, searchToText, fromLoc, consignees, consigners, routeCode, fromRange, toRange } = this.state;
		const { isError, autoSuggestLocations, rfqServiceType, networkData, saveRouteCode, rfq, zoneWiseDetails, ftlContractTypeList, masterRouteCodeDetails, consignorDetails } = this.props;
        return (
            <div className='vehicleDetails mt-20'>
                <div className='ph-20 pb-10'>
                <div className='pt-20 flex mb-20'>
                    <StopIcon />
                    <div className='ml-10 header'>Location Details And Stops</div>
                </div>
                    {stops.length > 1 && (stops || []).map((stop, index) => {
                        const fromType = `searchFromText-${index}`;
						const toType = `searchToText-1`;

						const fromText = this.state[fromType] || (!this.state.hasOwnProperty(fromType) && stop.location)  ||  '';
						const toText = this.state[toType] || (!this.state.hasOwnProperty(fromType) && stops[1].location) || '';

						const showFromSugguest = this.state[`show${fromType}Autosuggest`] || false;
						const showToSugguest = this.state[`show${toType}Autosuggest`] || false;

                        return(
                            <>
                                {index === 0 && <div className='flex mt-20'>
                                    <div className='col-2 mr-15 pr'>
                                        <div className='rfqlabel'>From <sup className='error-color fs-14'>*</sup></div>
                                        <Fragment>
                                            <Input
                                                name={fromType}
                                                value={fromText}
                                                onChange={(e) => { this.onChange(e, index) }}
                                            />
                                            {
                                                showFromSugguest && fromText && fromText.length > 0 &&  
                                                <ClickOutside handleClickOutside={() => this.onhideAutosuggest(`show${fromType}Autosuggest`)}>
                                                    <div className="mr-20 pa col-1 ht-300 border-light overflowAuto bg-white z-1">
                                                        {
                                                            fromText && fromText.length > 0 && ([...new Map(masterRouteCodeDetails.map((item) => [item["source"], item])).values()] || []).filter((item) => {
                                                                if (!fromText) {
                                                                    return true;
                                                                }
                                                                return (item['source'].toLowerCase().includes(fromText.toLowerCase()));
                                                            }).map((item, searchIndex) => {
                                                                return (
                                                                    <div
                                                                        key={searchIndex}
                                                                        name={item.city}
                                                                        className={"flex flex-middle pl-16 min-ht-40 fs-16 label-color bg-hover-theme pb-5 pt-8"}
                                                                        onClick={() => this.onSelect(fromType, item, index)}
                                                                    >
                                                                       
                                                                       <>{`${item.source}, ${item.source_district} ,${item.source_state}`}</> 
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </ClickOutside>
                                            }
                                        </Fragment>
                                        {isError && !stop.location && <div className={'error-color fs-14 fSemibold op-7 ml-5'}>{'Please Enter the location'}</div>}
                                    </div>
                                    <div className='col-2 ml-15'>
                                        <div className='rfqlabel'>Address</div>
                                            <Input 
                                                placeholder="Enter Address" 
                                                value={stop.landmark} 
                                                onChange={this.changeLandmark.bind(this, index)} 
                                            />
                                    </div>
                                </div>}
                                {index === 1 && <div className='flex mt-20'>
                                    <div className='col-2 mr-15 pr'>
                                        <div className='rfqlabel'>To <sup className='error-color fs-14'>*</sup></div>
                                        <Fragment>
														<Input
															name={toType}
															value={toText}
															onChange={(e) => { this.onChange(e, 1) }}
														/>
														{
															showToSugguest && toText && toText.length > 0 &&
															<ClickOutside handleClickOutside={() => this.onhideAutosuggest(`show${toType}Autosuggest`)}>
																<div className="mr-20 pa col-1 ht-300 border-light overflowAuto bg-white z-1">
																	{
																		toText && toText.length > 0 && (masterRouteCodeDetails || []).filter((item) => {
																			if (!toText) {
																				return true;
																			}
																			return (item['destination'].toLowerCase().includes(toText.toLowerCase()));
																		}).map((item, searchIndex) => {
																			return (
																				<div
																					key={searchIndex}
																					name={item.city}
																					className={"flex flex-middle pl-16 ht-40 fs-16 label-color bg-hover-theme pb-5 pt-8"}
																					onClick={() => this.onSelect(toType, item, 1)}
																				>
																					 <>{`${item.destination}, ${item.destination_district}, ${item.destination_state}`}</> 
																				
																				</div>
																			)
																		})
																	}
																</div>
															</ClickOutside>
														}
													</Fragment>
                                                    {isError && !stop.location && <div className={'error-color fs-14 fSemibold op-7 ml-5'}>{'Please Enter the location'}</div>}
                                    </div>
                                    <div className='col-2 ml-15'>
                                        <div className='rfqlabel'>Address</div>
                                        <Input 
                                            placeholder="Enter Address" 
                                            value={stop.landmark} 
                                            onChange={this.changeLandmark.bind(this, index)} />
                                    </div>
                                </div>}
                                {index === 1 && <div className='flex mt-20'>
                                    <div className='col-2 mr-15'>
                                        <div className='rfqlabel'>Route Code <sup className='error-color fs-14'>*</sup></div>
                                        <Input 
                                            placeholder="Enter Route Code"
                                            value={this.trip.routeCode || routeCode} 
                                            readOnly={true}
                                        />
                                        {(isError && !this.trip.routeCode) && <div className={'error-color fs-14 fSemibold op-7 ml-5'}>Route Code is Missing</div>}
                                    </div>
                                    <div className='col-2 ml-15'>
                                    </div>
                                </div>}
                                {index === 1 && <div className='flex mt-20'>
                                        <div className='col-2 mr-15'>
                                            <div className='rfqlabel'>Remarks</div>
                                            <Input placeholder="Enter Remarks" value={stops[0].remarks} onChange={this.changeRemarks.bind(this, 0)}/>
                                        </div>
                                        <div className='col-2 ml-15'>
                                            <div className='rfqlabel'>Remarks</div>
                                            <Input placeholder="Enter Remarks" value={stops[1].remarks} onChange={this.changeRemarks.bind(this, 1)}/>
                                        </div>
                                </div>}
                                {index > 1 && 
                                <div className='mt-10 border-status-bar br-5 pv-10 ph-10 pr'>
                                    <CloseIcon className="pa t--15 r--15 curP" onClick={this.removeStop.bind(this, index)} />
                                    <div className='header'>Stop {index - 1}</div>
                                    <div className='flex mt-20'>
                                        <div className='col-2 mr-15'>
                                            <div className='rfqlabel'>Location</div>
                                            <Fragment>
                                            <Input
                                                name={fromType}
                                                value={fromText}
                                                onChange={(e) => { this.onChange(e, index) }}
                                            />
                                            {
                                                showFromSugguest && fromText && fromText.length > 0 &&  
                                                <ClickOutside handleClickOutside={() => this.onhideAutosuggest(`show${fromType}Autosuggest`)}>
                                                    <div className="mr-20 pa col-1 ht-300 border-light overflowAuto bg-white z-1">
                                                        {
                                                            fromText && fromText.length > 0 && ([...new Map(masterRouteCodeDetails.map((item) => [item["source"], item])).values()] || []).filter((item) => {
                                                                if (!fromText) {
                                                                    return true;
                                                                }
                                                                return (item['source'].toLowerCase().includes(fromText.toLowerCase()));
                                                            }).map((item, searchIndex) => {
                                                                return (
                                                                    <div
                                                                        key={searchIndex}
                                                                        name={item.city}
                                                                        className={"flex flex-middle pl-16 min-ht-40 fs-16 label-color bg-hover-theme pb-5 pt-8"}
                                                                        onClick={() => this.onSelect(fromType, item, index)}
                                                                    >
                                                                       
                                                                       <>{`${item.source}, ${item.source_district} ,${item.source_state}`}</> 
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </ClickOutside>
                                            }
                                        </Fragment>
                                        </div>
                                        <div className='col-2 ml-15'>
                                            <div className='rfqlabel'>Address</div>
                                            <Input  
                                                placeholder="Enter Address" 
                                                value={stop.landmark} 
                                                onChange={this.changeLandmark.bind(this, index)}
                                            />
                                        </div>
                                    </div>
                                    <div className='flex mt-20'>
                                        <div className='col-2 mr-15'>
                                            <div className='rfqlabel'>Location</div>
                                            <div className="flex flex-middle">
                                                <Checkbox label="Pick" checked={stop.type === 1} className="mr-10" onCheck={this.changeStopType.bind(this, index, 1)} />
                                                <Checkbox label="Drop" checked={stop.type === 2} className="mr-10" onCheck={this.changeStopType.bind(this, index, 2)} />
                                                <Checkbox label="Pick & Drop" checked={stop.type === 3} onCheck={this.changeStopType.bind(this, index, 3)} />
                                            </div>
                                        </div>
                                        <div className='col-2 ml-15'>
                                            <div className='rfqlabel'>Additinal Price For This Stop</div>
                                            <Input 
                                                placeholder="Enter Price" 
                                                value={stop.additionalPrice} 
                                                onChange={this.changeAdditionalPrice.bind(this, index)}
                                            />
                                        </div>
                                    </div>
                                    <div className='flex mt-20'>
                                        <div className='col-2 mr-15'>
                                            <div className='rfqlabel'>Remarks</div>
                                            <Input placeholder="Enter Remarks" value={stop.remarks} onChange={this.changeRemarks.bind(this, index)}/>
                                        </div>
                                        <div className='col-2 ml-15'>
                                        </div>
                                    </div>
                                </div>}
                            </>
                        )})}
                    <div className='mt-10 mb-10'>
                        <button className='addStops curP' onClick={this.addStop}> <AddStopsIcon className='mr-5' /> Add Stop</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default StopDetails;